import { faqItems } from '@/mocks/darkwebData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问答
          </h2>
          <p className="text-foreground-600 text-sm mt-2">
            关于51暗网，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6"
            >
              <h3 className="font-heading text-base font-semibold text-foreground-950 mb-3">
                <span className="text-primary-500 mr-2">Q{String(item.id).padStart(2, '0')}</span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}